import React, { useState } from "react";
import "./Header.css";

const Header = ({ title, type, image }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [extranetOpen, setExtranetOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header
      className="header"
      style={{
        backgroundImage: `linear-gradient(rgba(23, 32, 58, 0.7), rgba(23, 32, 58, 0.7)), url("${image}")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "#17203a", // Couleur de secours si l'image ne charge pas
      }}
    >
      <div className="header-content">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/acafc4656fe8f0effa93a4d194df7197df192b2d2f236e1d005780cad536cf8a?apiKey=59156c16963f46e28d2e0d857e2bfa45&"
          alt="Company Logo"
          className="logo"
        />
        {/* Bouton Burger */}
        <button className="burger-menu" onClick={toggleMenu}>
          <span className="burger-icon"></span>
          <span className="burger-icon"></span>
          <span className="burger-icon"></span>
        </button>

        {/* Menu Desktop */}
        <nav className={`main-nav ${menuOpen ? "menu-open" : ""}`}>
          <ul>
            <li><a href="/">Accueil</a></li>
            <li><a href="../../formations">Formations</a></li>
            <li><a href="/blog">Blog</a></li>
            <li><a href="/calendrier">Calendrier</a></li>
            <li><a href="/quisommesnous">Qui sommes-nous</a></li>
            <li><a href="/avis">Avis</a></li>
            <li><a href="/contact">Contact</a></li>
            <li
              className="dropdown"
              onClick={() => setExtranetOpen(!extranetOpen)}
            >
              <a href="#">Extranet ▾</a>
              {extranetOpen && (
                <ul className="dropdown-menu">
                  <li><a href="https://sc-formation-prevention-secours.hop3team.com/learners/sign_in">Participants</a></li>
                  <li><a href="https://sc-formation-prevention-secours.hop3team.com/speakers/sign_in">Formateurs</a></li>
                </ul>
              )}
            </li>
          </ul>
        </nav>
      </div>

      {/* Section Hero */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">{title}</h1>
          {type ? <div className={`hero-category-${type}`}>{type}</div> : null}
        </div>
      </section>
    </header>

  );
};

export default Header;